import React from 'react';

/**
 * Animated SVG checkmark drawn on milestone completion.
 */
export default function MilestoneCompletionCheck({ size = 22 }) {
  return (
    <svg
      className="flowchart-hud__milestone-check-svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        className="flowchart-hud__milestone-check-circle"
        cx="12"
        cy="12"
        r="10"
      />
      <path
        className="flowchart-hud__milestone-check-stroke"
        d="M7.5 12.5 L10.5 15.5 L16.5 8.5"
        stroke="white"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
